import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=76c6cd12&functional=true"
import script from "./cancel.vue?vue&type=script&lang=js"
export * from "./cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports